import React from 'react';
import { Container, Row } from 'react-bootstrap';
import HomeLandingPage from './HomeLandingPage/HomeLandingPage';
import { useUser } from '../../../Context/UserContext';
import NcwLogin from './NcwLogin/NcwLogin';
import CenteredLoadingSpinner from '../../../Abstracts/LoadingSpinnerV2/CenteredLoadingSpinner';
// @ts-ignore
import styles from './Home.module.scss?module';

export default function Home() {
  const { user, isSuccess, loading } = useUser();

  return (
    <>
      {loading ? (
        <CenteredLoadingSpinner />
      ) : isSuccess && !user ? (
        <NcwLogin />
      ) : (
        <Container
          fluid
          className="d-flex flex-column gap-4 position-relative p-0"
        >
          <HomeLandingPage />

          <Row aria-label="spacer" />
        </Container>
      )}
    </>
  );
}
